import {Injectable} from '@angular/core';

@Injectable()
export class CommandsGuiHTML {
    constructor() {

    }

    createHtmlView() {
    }

    htmlViewBack() {
    }

    htmlViewCurrentUrl() {
    }

    htmlViewEventUrl() {
    }

    htmlViewForward() {
    }

    htmlViewGo() {
    }

    htmlViewRun() {
    }

    htmlViewStatus() {
    }
}
